module.exports = function (lvalue, options) {
    if (arguments.length < 2)
        throw new Error("Handlebars Helper equal needs 2 parameters");
    if (/^([A-Z]{2}\s)?[0-9]+([\.\s]?[0-9]*)*$/.test(lvalue)) {
        return options.fn(this);
    } else {
        return options.inverse(this);
    }
};


//////////////////
// WEBPACK FOOTER
// ./Frontend/src/hbHelpers/isid.js
// module id = 53
// module chunks = 0